/** Imperative PWA update helpers for Settings (banner also binds apply). */

type ApplyUpdate = (reloadPage?: boolean) => Promise<void>;

let applyUpdate: ApplyUpdate | null = null;
let registration: ServiceWorkerRegistration | null = null;

export function bindPwaUpdateControls(opts: {
  registration: ServiceWorkerRegistration | null | undefined;
  updateServiceWorker: ApplyUpdate;
}): void {
  registration = opts.registration ?? null;
  applyUpdate = opts.updateServiceWorker;
}

export type PwaCheckResult = 'updated' | 'available' | 'current' | 'unavailable';

/**
 * Ask the service worker to check for a new version.
 * If a waiting worker exists, apply it (skipWaiting + reload).
 */
export async function checkForAppUpdate(): Promise<PwaCheckResult> {
  if (!('serviceWorker' in navigator)) return 'unavailable';

  let reg = registration;
  try {
    reg = (await navigator.serviceWorker.getRegistration()) ?? reg;
  } catch {
    return 'unavailable';
  }
  if (!reg) return 'unavailable';

  try {
    await reg.update();
  } catch {
    // Still inspect waiting/installing below.
  }

  const waiting = reg.waiting;
  if (waiting) {
    if (applyUpdate) {
      await applyUpdate(true);
      return 'updated';
    }
    waiting.postMessage({ type: 'SKIP_WAITING' });
    window.location.reload();
    return 'updated';
  }

  if (reg.installing) {
    return 'available';
  }

  return 'current';
}
